<template>
	<div>
		<b-form-row>
			<b-col cols="12" md="4">
				<input-component
					v-model="cep"
					:check="true"
					:required="true"
					label="CEP"
					mask="#####-###"
					maxlength="9"
					name="cep"
					@input="getAddress" />
			</b-col>

			<b-col cols="12" md="8">
				<input-component ref="street" v-model="street" :required="true" label="Endereço" name="street" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="6" md="4">
				<input-component v-model="number" :required="true" label="Número" maxlength="6" name="number" />
			</b-col>

			<b-col cols="6" md="8">
				<input-component v-model="complement" label="Complemento" maxlength="150" name="complement" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="4">
				<input-component ref="city" v-model="city" :required="true" label="Cidade" name="city" />
			</b-col>

			<b-col cols="12" md="4">
				<input-component ref="state" v-model="state" :required="true" label="Estado" name="state" />
			</b-col>

			<b-col cols="12" md="4">
				<select-component
					ref="country"
					v-model="country"
					:options="countries"
					:required="true"
					label="País"
					name="country" />
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
	import axios from "axios";

	import { minLength, numeric, required } from "vuelidate/lib/validators";
	import countries from "@/static/countries";

	import InputComponent from "@/components/Form/Inputs/InputComponent";
	import SelectComponent from "@/components/Form/Inputs/SelectComponent";

	export default {
		name: "AddressFormComponent",
		components: {
			InputComponent,
			SelectComponent,
		},
		beforeMount() {
			this.type = this.$vnode.data.ref != "mainAddress" ? 1 : 0;
		},
		async mounted() {
			if (this.cep) {
				await this.getAddress();
			}

			this.$refs.country.value = "Brasil";
		},
		data: () => ({
			validCep: false,
			type: 0,
		}),
		computed: {
			street: {
				get() {
					return this.$store.state.form.establishment.address[this.type].street;
				},
				set(value) {
					this.$store.commit("setEstablishmentAddress", {
						index: this.type,
						key: "street",
						value,
					});
				},
			},
			cep: {
				get() {
					return this.$store.state.form.establishment.address[this.type].cep;
				},
				set(value) {
					this.$store.commit("setEstablishmentAddress", {
						index: this.type,
						key: "cep",
						value,
					});
				},
			},
			number: {
				get() {
					return this.$store.state.form.establishment.address[this.type].number;
				},
				set(value) {
					this.$store.commit("setEstablishmentAddress", {
						index: this.type,
						key: "number",
						value,
					});
				},
			},
			complement: {
				get() {
					return this.$store.state.form.establishment.address[this.type].complement;
				},
				set(value) {
					this.$store.commit("setEstablishmentAddress", {
						index: this.type,
						key: "complement",
						value,
					});
				},
			},
			city: {
				get() {
					return this.$store.state.form.establishment.address[this.type].city;
				},
				set(value) {
					this.$store.commit("setEstablishmentAddress", {
						index: this.type,
						key: "city",
						value,
					});
				},
			},
			state: {
				get() {
					return this.$store.state.form.establishment.address[this.type].state;
				},
				set(value) {
					this.$store.commit("setEstablishmentAddress", {
						index: this.type,
						key: "state",
						value,
					});
				},
			},
			country: {
				get() {
					return this.$store.state.form.establishment.address[this.type].country;
				},
				set(value) {
					this.$store.commit("setEstablishmentAddress", {
						index: this.type,
						key: "country",
						value,
					});
				},
			},
			countries: () => countries,
		},
		methods: {
			async getAddress() {
				const cep = this.cep.replace(/\D/g, "");

				if (cep.length !== 8) {
					return;
				}

				let res = await axios.get(`https://viacep.com.br/ws/${cep}/json/`).catch((err) => console.error(err));

				if (res.status !== 200 || res.data.erro) {
					this.validCep = false;
					return;
				}

				this.validCep = true;

				this.$refs.street.value = res.data.logradouro;
				this.$refs.city.value = res.data.localidade;
				this.$refs.state.value = res.data.uf;
			},
		},
		validations: {
			cep: {
				required,
				minLength: minLength(9),
				validCep: function () {
					return this.validCep;
				},
			},
			street: {
				required,
			},
			number: {
				required,
				numeric,
			},
			city: {
				required,
			},
			state: {
				required,
			},
			country: {
				required,
			},
			complement: {},
		},
	};
</script>
